













import {
  computed,
  defineNuxtComponent,
  ref,
  watch
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import CTreeSelect from '~/components/shared/configurable/form/select/tree/CTreeSelect.vue'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import { debounce } from '~/utils/function'

export default defineNuxtComponent({
  components: {
    CFormGroup,
    CTreeSelect
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)
    const selectedLocations = ref(facet.value.values?.selected || [])
    const localSelectedLocations = ref(facet.value.values?.selected || [])
    const isUserInteracting = ref(false)

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }
        selectedLocations.value = facet.value.values?.selected || []

        // Only update localSelectedLocations if user is not currently interacting
        if (!isUserInteracting.value) {
          localSelectedLocations.value = facet.value.values?.selected || []
        }
      }
    )

    const options = computed(() => {
      return (
        facet.value.searchables.map((item: any) => ({
          value: item.v,
          label: item.n,
          count: item.c,
          children: item.k
            ? item.k.map((child: any) => ({
                value: child.v,
                label: child.n,
                count: child.c
              }))
            : []
        })) || []
      )
    })

    const emitModelUpdate = debounce((newValue: string[]) => {
      isUserInteracting.value = false
      emit('update:modelValue', {
        name: facet.value.urlargNames[0],
        value: newValue
      })
    })

    function handleChange(newValue: string[]) {
      isUserInteracting.value = true
      localSelectedLocations.value = newValue
      emitModelUpdate(newValue)
    }

    return {
      facet,
      selectedLocations,
      localSelectedLocations,
      options,
      handleChange
    }
  },
  i18n: defineComponentTranslations({
    all_regions: {
      en: 'All Regions',
      el: 'Όλες οι περιοχές'
    }
  })
})
